module.exports = __webpack_public_path__ + "img/sld_scb_1_t1_red.551c945f.svg";